<template lang="pug">
sidebar-menu.sidebar(ref="menu",:menu="sideMenu",@toggle-collapse="onToggleCollapse",:collapsed="collapsed",width="15rem",widthCollapsed="5rem",:disableHover="true",:hideToggle="false",:relative="true",v-if="$auth.isAuthenticated && currentUser")
  .brand(slot="header")
    .logo(@click="handleLink(`/${$route.params.directory}/`)")
</template>

<script>
import { SidebarMenu } from 'vue-sidebar-menu'

// import { wait } from '../../utils/libs'

export default {
  components: {
    SidebarMenu
  },
  data () {
    return {
      page: null,
      currentUser: null,
      sideMenu: [{
        href: `/${this.$route.params.directory}/`,
        alias: [`/${this.$route.params.directory}/?*`],
        title: 'ダッシュボード',
        icon: 'fas fa-tachometer-alt',
        class: 'dashboard',
        disabled: true
      }, {
        href: `/${this.$route.params.directory}/summary`,
        alias: [`/${this.$route.params.directory}/summary/*`],
        title: '選考状況サマリー',
        icon: 'fas fa-chart-bar',
        class: 'summary',
        disabled: true
      }, {
        href: `/${this.$route.params.directory}/peoples`,
        alias: [`/${this.$route.params.directory}/people/*`],
        title: '候補者',
        icon: 'fas fa-users',
        class: 'peoples',
        disabled: true
      }, {
        href: `/${this.$route.params.directory}/jobs`,
        alias: [`/${this.$route.params.directory}/job/*`],
        title: 'ポジション',
        icon: 'fas fa-file-alt',
        class: 'jobs',
        disabled: true,
        hidden: false
      }, {
        href: `/${this.$route.params.directory}/routes`,
        alias: [`/${this.$route.params.directory}/route/*`],
        title: '採用ルート',
        icon: 'fas fa-route',
        class: 'routes',
        disabled: true,
        hidden: false
      }, {
        href: `/${this.$route.params.directory}/users`,
        alias: [`/${this.$route.params.directory}/user/*`],
        title: 'メンバー',
        icon: 'fas fa-address-card',
        class: 'users',
        disabled: true,
        hidden: false
      }, {
        href: `/${this.$route.params.directory}/boilerplates`,
        alias: [`/${this.$route.params.directory}/boilerplate/*`],
        title: 'テンプレート',
        icon: 'fas fa-edit',
        class: 'boilerplates',
        disabled: true,
        hidden: false
      }, {
        href: `/${this.$route.params.directory}/setup/profile`,
        alias: [`/${this.$route.params.directory}/setup/*`],
        title: '設定・変更',
        icon: 'fas fa-cog',
        class: 'setup',
        disabled: true
      }],
      collapsed: false
    }
  },
  watch: {
    collapsed (val) {
      this.$parent.collapsed = val
    },
    currentUser () {

      if (this.currentUser && this.currentUser.role !== 'agent') {
        this.sideMenu[0].disabled = false
        this.sideMenu[0].hidden = false
      } else {
        this.sideMenu[0].disabled = true
        this.sideMenu[0].hidden = true
      }
    
      if (this.currentUser && this.currentUser.role !== 'agent') {
        this.sideMenu[1].disabled = false
        this.sideMenu[1].hidden = false
      } else {
        this.sideMenu[1].disabled = true
        this.sideMenu[1].hidden = true
      }

      this.sideMenu[2].disabled = false
      this.sideMenu[2].hidden = false

      if (this.currentUser && this.currentUser.acl) {
        if (this.currentUser.acl.jobs && this.currentUser.acl.jobs.get) {
          this.sideMenu[3].disabled = false
          this.sideMenu[3].hidden = false
        } else {
          this.sideMenu[3].disabled = true
          this.sideMenu[3].hidden = true
        }

        if (this.currentUser.acl.routes && this.currentUser.acl.routes.get && this.currentUser.role !== 'agent') {
          this.sideMenu[4].disabled = false
          this.sideMenu[4].hidden = false
        } else {
          this.sideMenu[4].disabled = true
          this.sideMenu[4].hidden = true
        }

        if (this.currentUser.acl.users && this.currentUser.acl.users.get && this.currentUser.role !== 'agent') {
          this.sideMenu[5].disabled = false
          this.sideMenu[5].hidden = false
        } else {
          this.sideMenu[5].disabled = true
          this.sideMenu[5].hidden = true
        }

        if (this.currentUser.acl.boilerplates && this.currentUser.acl.boilerplates.get && (this.currentUser.role !== 'consultant' && this.currentUser.role !== 'agent')) {
          this.sideMenu[6].disabled = false
          this.sideMenu[6].hidden = false
        } else {
          this.sideMenu[6].disabled = true
          this.sideMenu[6].hidden = true
        }
      }

      this.sideMenu[7].disabled = false
    }
  },
  created () {
    this.collapsed = this.$store.state.menuCollapsed
  },
  async mounted () {
    this.page = this.$parent.page

    this.$parent.collapsed = this.collapsed

    this.loadData()
  },
  methods: {
    onToggleCollapse (val) {
      this.collapsed = val
      this.$store.commit('setMenuCollapsed', this.collapsed)
    },
    loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)
    }
  }
}
</script>

<style scoped lang="stylus">
</style>

<style lang="stylus">
$collapseWidth = 5rem
$expandWidth = 15rem

$menuWidth = 16rem
$detailLeftMargin = 16rem

.v-sidebar-menu
  position fixed !important
  top 0
  left 0
  z-index 998
  min-height 100vh

  .brand
    height 3.75rem
    margin-bottom 1rem
    .logo
      margin 1.125rem 0 0.75rem 1.5rem
      width 'calc(%s - (1rem * 2) - 0.8rem)' % $collapseWidth
      height calc(3.75rem - (0.8rem * 2))
      background-image url('../../assets/images/logo-mini.svg')
      background-repeat no-repeat
      background-size contain
      cursor pointer

  &.vsm_collapsed
    .vsm--mobile-item
      display none !important

  &.vsm_expanded
    .brand
      .logo
        margin-top 1rem
        margin-left 2.25rem
        width 'calc(%s - (2.25rem * 2))' % $expandWidth
        height calc(3.75rem - (0.5rem * 2))
        background-image url('../../assets/images/logo.svg')

  .vsm--toggle-btn
    position fixed
    bottom 0
    width $collapseWidth
    background-color #fc9649
    height 3.375rem
  &.vsm_expanded
    .vsm--toggle-btn
      width $expandWidth

  .vsm--item
    display flex
    align-items center

  .vsm--link
    color #555
    font-weight 300
    font-size .875rem
    width 100%
    text-align center
    display block

  &.vsm_expanded
    .vsm--link
      text-align left
      margin-left 0.5rem

  .vsm--link_level-1
    .vsm--icon
      background-color transparent !important
      color #ccc
      margin-right 0
    &.vsm--link_exact-active
    &.vsm--link_active
      box-shadow 0 0 0 0
      .vsm--icon
        background-color transparent !important
        color #fc9649
      &:after
        position absolute
        content ''
        height 40px
        width 4px
        background-color #e24508
        right 0
        top calc(50% - 20px)
    &.vsm--link_hover
    &:hover
      color #e83
      background-color transparent !important
      font-weight 600
      .vsm--icon
        color #fc9649 !important

.page
  width 'calc(100% - %s)' % $collapseWidth
  margin-left $collapseWidth
.body
  .right
    width 'calc(100vw - %s - %s)' % ($collapseWidth $menuWidth)
    min-width 'calc(991px - %s - %s)' % ($collapseWidth $menuWidth)
  .detail
  .detail header
  .detail footer
    width 'calc(100vw - %s - %s)' % ($collapseWidth $detailLeftMargin)
    min-width 'calc(991px - %s - %s)' % ($collapseWidth $detailLeftMargin)
  .table-responsive+.fixed-bottom
    width 'calc(100vw - %s)' % $collapseWidth
    left $collapseWidth
  .right .table-responsive+.fixed-bottom
    width 'calc(100vw - %s - %s)' % ($collapseWidth $menuWidth)
    left 'calc(%s + %s)' % ($collapseWidth $menuWidth)

.narrow
  .page
    width 'calc(100% - %s)' % $expandWidth
    margin-left $expandWidth
  .body
    .right
      width 'calc(100vw - %s - %s)' % ($expandWidth $menuWidth)
      min-width 'calc(991px - %s - %s)' % ($expandWidth $menuWidth)
    .detail,
    .detail header
    .detail footer
      width 'calc(100vw - %s - %s)' % ($expandWidth $detailLeftMargin)
      min-width 'calc(991px - %s - %s)' % ($expandWidth $detailLeftMargin)
    .table-responsive+.fixed-bottom
      width 'calc(100vw - %s)' % $expandWidth
      left $expandWidth
    .right .table-responsive+.fixed-bottom
      width 'calc(100vw - %s - %s)' % ($expandWidth $menuWidth)
      left 'calc(%s + %s)' % ($expandWidth $menuWidth)
</style>
